import React, { FC } from 'react'
import { CircularProgress } from '@mui/material'
import { ReactComponent as Logo } from '../../../assets/images/logo.svg'
import './loader.scss'
import { conditionalClasses } from '../../../utils/helper-functions'

interface LoaderProps {
    transparent?: boolean
    _class?: string
    isBlackFill?: boolean
}

const Loader: FC<LoaderProps> = ({
    transparent = false,
    isBlackFill = true,
    _class = '',
}) => {
    return (
        <div className={`loader ${transparent && 'transparent'} ${_class}`}>
            <div className="loader-container">
                <CircularProgress size={92} thickness={2} />
                <Logo
                    className={conditionalClasses(
                        isBlackFill,
                        'black-fill',
                        '',
                        'logo'
                    )}
                />
            </div>
        </div>
    )
}

export default Loader
